import React, { useEffect, useState } from "react";
import { Modal } from "@pd/pd-ui-kit";
import { useTranslation } from "react-i18next";

import Preloader from "~/components/Preloader";
import { useAddAdditional, useDefaultDataAdditional } from "~/entity/Contract";
import { dateFormatUTC } from "~/pages/ListOfDocuments/helper";
import {
  additionalFormId,
  FormAdditional,
} from "~/pages/ListOfDocuments/Modals/Components/FormAdditional";
import { TITLES } from "~/pages/ListOfDocuments/Modals/options";
import { useNotify } from "~/shared/hooks/useNotify";

interface CreateContractIProps {
  open: boolean;
  onClose: () => void;
  dealerObj: any;
}

const defaultValues = {
  inn: "",
  code: "",
  name: "",
  category: "",
  isHeadCompany: "",
  contractNumberParent: "",
  contractDateParent: "",
  parentContractId: "", //hidden
  contractNumber: "",
  contractDate: "",
  startForPrint: "",
  closeForPrint: "",
  confidantId: "",
  printFormId: "",
  startDateForIS: "",
  closeDateForIS: "",
  dealerSignedDate: "",
  ursosSignedDate: "",
};

const CreateAdditional = ({
  open,
  onClose,
  dealerObj,
}: CreateContractIProps) => {
  const [defaultValuesAdditional, setDefaultValuesAdditional] =
    useState(defaultValues);
  const [loading, setLoading] = useState(false);
  const { notifySuccess, notifyError } = useNotify();
  const { t } = useTranslation();
  const { data, isLoading } = useDefaultDataAdditional(dealerObj.id);

  const { mutate } = useAddAdditional();

  useEffect(() => {
    if (data && !isLoading) {
      Object.keys(data).forEach((key) => {
        setDefaultValuesAdditional((state) => {
          return { ...state, [key]: data[key] };
        });
      });
      setLoading(true);
    }
  }, [data, isLoading]);

  const submit = (data) => {
    const newData = {
      dealerId: Number(dealerObj.id),
      confidantId: Number(data.confidantId.value),
      contractType: "additional",
      parentContractId: Number(data.parentContractId),
      contractNumber: data.contractNumber,
      startDateForIS: data.startDateForIS
        ? dateFormatUTC(data.startDateForIS)
        : "",
      closeDateForIS: data.closeDateForIS
        ? dateFormatUTC(data.closeDateForIS)
        : "",
      contractDate: dateFormatUTC(data.contractDate),
      dealerSignedDate: data.dealerSignedDate
        ? dateFormatUTC(data.dealerSignedDate)
        : "",
      ursosSignedDate: data.ursosSignedDate
        ? dateFormatUTC(data.ursosSignedDate)
        : "",
      startForPrint: dateFormatUTC(data.startForPrint),
      closeForPrint: dateFormatUTC(data.closeForPrint),
      printFormId: Number(data.printFormId.value),
    };

    mutate(
      {
        ...newData,
      },
      {
        onSuccess: () => {
          notifySuccess(t("contract.create_additional_success"));
          onClose();
        },
        onError: () => {
          notifyError(t("contract.create_additional_error"));
        },
      },
    );
  };

  const formReady = !isLoading && loading;

  return (
    <Modal
      open={open}
      title={TITLES.additional.create}
      onCancel={onClose}
      centered
      destroyOnHidden
      size="large"
      cancelButton={{ children: "Закрыть" }}
      okButton={
        formReady
          ? {
              htmlType: "submit",
              form: additionalFormId,
              children: "Сохранить",
            }
          : undefined
      }
    >
      {formReady ? (
        <FormAdditional
          submit={submit}
          defaultValues={defaultValuesAdditional}
        />
      ) : (
        <Preloader />
      )}
    </Modal>
  );
};

export default CreateAdditional;
